import { fork, all, setContext } from 'redux-saga/effects';
import { userWatcher } from './userWatcher';
import { routingWatcher } from './routing';
import { analyticsWatcher } from './analytics';
import { contactPageWatcher } from './contactPageWatcher';
import { listingCardWatcher } from './listingCardWatcher';
import { apiServiceWorker } from './apiService';
import { saveSearchWatcher } from './saveSearchWatcher';
import { viewedPoiWatcher } from './viewedPoiPersistance';
import { toggleAddressWatcher } from 'store/sagas/toggleAddressWatcher';
import { ugcReviewWizardWatcher } from './ugcWizardWatcher';
import { addEditBulletinWatcher } from './addEditBulletinWatcher';
import { createListingAndPayForPlanSaga } from './createListingAndPayForPlanSaga';
import { busLineWatcher } from './busLineWatcher';
import { toggleFavoritesWatcher } from 'store/sagas/favoritesWatcher';
import { fetchFavoritesWatcher } from 'store/sagas/fetchFavoritesWatcher';
import { reactNativeWatcher } from 'react-native/sagas';
import { searchViewWatcher } from 'store/sagas/searchViewWatcher';
import { mobileDiscoveryPopupWatcher } from './mobileDiscoveryWatcher';
import { pushNotificationsModalWatcher } from './pushNotificationsModalWatcher';
import { privateUserMonetizationWatcher } from './privateUserMonetizationWatcher';
import { paymentWatcher } from './paymentWatcher';
import { pricesWatcher } from 'store/sagas/pricesWatcher';
import { realEstateOfficeWatcher } from './realEstateOfficeWatcher';
import { realEstateAgentWatcher } from './realEstateAgentWatcher';
import { fetchSoldDealBannerDataWatcher } from './fetchSoldDealBannerDataWatcher';
import { menuDotWatcher } from './menuDotWatcher';
import { investorsWatcher } from './routing/handlers/investors';
import { cookieWatcher } from './cookieWatcher';
import { tranzilaHostedFieldsWatcher } from './tranzilaHostedFieldsWatcher';

export default function* rootSaga(logger = console) {
  yield setContext({ logger });
  yield all([
    fork(viewedPoiWatcher),
    fork(userWatcher),
    fork(routingWatcher),
    fork(analyticsWatcher),
    fork(contactPageWatcher),
    fork(listingCardWatcher),
    fork(apiServiceWorker),
    fork(toggleAddressWatcher),
    fork(saveSearchWatcher),
    fork(ugcReviewWizardWatcher),
    fork(addEditBulletinWatcher),
    fork(createListingAndPayForPlanSaga),
    fork(busLineWatcher),
    fork(toggleFavoritesWatcher),
    fork(fetchFavoritesWatcher),
    fork(reactNativeWatcher),
    fork(searchViewWatcher),
    fork(mobileDiscoveryPopupWatcher),
    fork(pushNotificationsModalWatcher),
    fork(pricesWatcher),
    fork(realEstateOfficeWatcher),
    fork(realEstateAgentWatcher),
    fork(privateUserMonetizationWatcher),
    fork(paymentWatcher),
    fork(fetchSoldDealBannerDataWatcher),
    fork(menuDotWatcher),
    fork(investorsWatcher),
    fork(cookieWatcher),
    fork(tranzilaHostedFieldsWatcher),
  ]);
}
